export default __webpack_public_path__ + "static/media/empty-notification.f0d3b24c.svg";